// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { copy16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-copy': IconCopy;
    }
}

/**
 * The icon component for the 'copy' icon
 */
export class IconCopy extends Icon {
    public constructor() {
        super(copy16X16);
    }
}

registerIcon('icon-copy', IconCopy);
export const iconCopyTag = 'nimble-icon-copy';
